import React from 'react';

const CasOrgsTabel = ({ isSpecialtyOrOrg = undefined, casOrganizations }) => {
  return (
    <table className={'cas-org-container'}>
      <thead>
        <tr className="parent-row">
          <th className="left-col">CAS</th>
          <th className="right-col">{isSpecialtyOrOrg || 'Organization'}</th>
        </tr>
      </thead>
      <tbody>
        {Array.from(casOrganizations).map(function (cas, casIndex) {
          const singleRow = cas.clients.length === 1;
          const lastCasRow = casOrganizations.length === casIndex + 1;

          return (
            <React.Fragment key={casIndex}>
              <tr className={`parent-row ${singleRow ? 'single-row' : ''} ${lastCasRow ? 'last-parent' : ''}`}>
                <td className={`left-col`} rowSpan={cas.clients.length}>
                  {cas.name}
                </td>
                <td className={`right-col`}>{cas.clients[0].name}</td>
              </tr>
              {cas.clients.slice(1).map((client, indexInner) => {
                const lastRow = cas.clients.length === indexInner + 2 && lastCasRow;
                return (
                  <tr key={client.id} className={`inner-row ${lastRow ? 'last-inner-row' : ''}`}>
                    <td className={'right-col single'}>{client.name}</td>
                  </tr>
                );
              })}
            </React.Fragment>
          );
        })}
      </tbody>
    </table>
  );
};

export default CasOrgsTabel;
